<template>
  <div class="subscription-bar__social-media">
    <!-- Title -->
    <h3 class="subscription-bar__social-media__title">
      {{ $i18n('blog.our-socials') }}
    </h3>
    <!-- ./Title -->

    <!-- Social Media Icons -->
    <Socials icon-class="text-[#0e1017] hover:text-blue-600 duration-200" />
    <!-- ./Social Media Icons -->
  </div>
</template>
<script>
import Socials from '~/components/Socials.vue';

export default {
  name: 'SocialMedia',
  components: {
    Socials,
  },
};
</script>
<style lang="scss">
.subscription-bar {
  &__social-media {
    @apply block;

    &__title {
      @apply font-cocogoose text-[20px] mb-[10px];
    }
  }
}
</style>
